import React from "react";
import { Spinner } from "reactstrap";

const Splash = () => {
    return(
        <div className='vh-100 d-flex align-items-center justify-content-center'><Spinner color="dark" size={"sm"} /></div>
    );
}

export default Splash;